import {MAP_MODES} from '@src/constants/map.ts';
import {useStore} from '@src/stores/useStore.ts';
import {useMemo} from 'react';

const useMapMode = () => {
  const pathname = useStore(state => state.app.pathname);

  return useMemo(() => {
    const [basePath] = pathname.slice(1).split('/');

    let mapMode = '';

    switch (basePath) {
      case 'mosaics':
        mapMode = MAP_MODES.MOSAICS;
        break;
      case 'explorer':
        mapMode = MAP_MODES.SEARCH;
        break;
      case 'aois':
        mapMode = MAP_MODES.FEATURES;
        break;
      case 'browse':
      case 'visualize':
      case 'analyze':
        mapMode = MAP_MODES.ANALYZE;
        break;
      case 'subscriptions':
        mapMode = MAP_MODES.SUBSCRIPTIONS;
        break;
      case 'saved-searches':
        mapMode = MAP_MODES.SAVED_SEARCHES;
        break;
      default:
        mapMode = '';
    }

    return {
      mapMode,
      isMosaicsMode: mapMode === MAP_MODES.MOSAICS,
      isSearchMode: mapMode === MAP_MODES.SEARCH,
      isFeaturesMode: mapMode === MAP_MODES.FEATURES,
      isAnalyzeMode: mapMode === MAP_MODES.ANALYZE,
      isSubscriptionsMode: mapMode === MAP_MODES.SUBSCRIPTIONS,
    };
  }, [pathname]);
};

export default useMapMode;
